let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d9EB0")).then(() => parcelRequire('b7Cg1'));